import { ComponentsOverrides, Theme } from "@mui/material";
import { InternalThemeConfig } from "../../config";

const listItem = ({ spacing }: InternalThemeConfig): ComponentsOverrides<Theme>["MuiListItem"] => ({
	gutters: {
		paddingLeft: `${spacing(3)}`,
		paddingRight: `${spacing(3)}`,
	},
});

export default listItem;
